import { render, staticRenderFns } from "./NavMenu.vue?vue&type=template&id=c10675ce&scoped=true"
import script from "./NavMenu.vue?vue&type=script&lang=js"
export * from "./NavMenu.vue?vue&type=script&lang=js"
import style0 from "./NavMenu.vue?vue&type=style&index=0&id=c10675ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c10675ce",
  null
  
)

export default component.exports